import React from 'react';

function TwitterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="12"
      fill="none"
      viewBox="0 0 14 12"
    >
      <path
        fill="#fff"
        d="M14 1.392a5.743 5.743 0 01-1.65.452A2.88 2.88 0 0013.613.255c-.555.33-1.17.568-1.824.697a2.872 2.872 0 00-4.894 2.62A8.154 8.154 0 01.975.57a2.871 2.871 0 00.889 3.835 2.86 2.86 0 01-1.301-.36v.036c0 1.392.99 2.553 2.303 2.817a2.876 2.876 0 01-1.297.049 2.875 2.875 0 002.683 1.995A5.763 5.763 0 010 10.132a8.13 8.13 0 004.403 1.29c5.283 0 8.172-4.376 8.172-8.172 0-.124-.003-.248-.008-.371A5.839 5.839 0 0014 1.392z"
      />
    </svg>
  );
}

export default TwitterIcon;
